import React from 'react';
import Footer from '../Footer/Footer';
//import OnlineCourses from '../allcourses/OnlineCourses';
import Contact from '../Contact/Contact';
import AllCourses from '../Courses/allcourses';


function CoursesPage() {
  return (
    <div>
      <AllCourses/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default CoursesPage;
